import React from 'react';

const Cover = () => {
    return (
        <div className="cover-container" id="home-a" name="home">
            <div className="cover-overlay">
                <h1 className="cover-title">WELCOME TO STARTUP</h1>
                <p className="cover-text">Your Favourite Creative Agency Template</p>
                <button className="get-started-btn">GET STARTED</button>
            </div>
        </div>
    )
}

export default Cover;